import { useState, useEffect } from 'react';
import { useConsultationModal } from '@/hooks/useConsultationModal';
import ConsultationInquiryForm from './ConsultationInquiryForm';
import { useParams } from 'react-router-dom';

export default function ConsultationInquiryModal() {
  const { isOpen, close } = useConsultationModal();
  const [submitted, setSubmitted] = useState(false);

  const { shopSlug } = useParams();
  useEffect(() => {
    if (!isOpen) {
      setSubmitted(false);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        close();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, close]);

  if (!isOpen) return null;

  const handleSuccess = () => {
    setSubmitted(true);
    close();
  };

  const modalContent = submitted ? (
    <div className="flex flex-col items-center text-center px-2 py-6">
      <div className="w-14 h-14 rounded-full bg-[#F7F2EA] flex items-center justify-center mb-4">
        <i className="ri-check-line text-2xl text-[#B9965B]" />
      </div>
      <h3 className="text-[16px] font-bold text-[#121B35]">
        상담 문의가 접수되었습니다.
      </h3>
      <p className="text-[13px] text-[#536079] mt-2 leading-relaxed">
        빠르게 연락드릴게요.
      </p>
      <button
        onClick={close}
        className="mt-5 w-full bg-[#121B35] text-white font-semibold rounded-xl py-3 text-[14px] whitespace-nowrap active:opacity-90 transition-opacity"
      >
        닫기
      </button>
    </div>
  ) : (
    <>
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-[16px] font-bold text-[#121B35]">상담 문의하기</h3>
        <button
          onClick={close}
          className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-[#F7F2EA] transition-colors"
          aria-label="닫기"
        >
          <i className="ri-close-line text-[#536079] text-lg" />
        </button>
      </div>
      <ConsultationInquiryForm slug={shopSlug} onSuccess={handleSuccess} />
    </>
  );

  return (
    <div className="fixed inset-0 z-[100]">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/30"
        onClick={close}
      />

      {/* Desktop: centered modal */}
      <div className="hidden lg:flex absolute inset-0 items-center justify-center p-4">
        <div
          className="relative bg-white rounded-2xl w-full max-w-[440px] max-h-[90dvh] overflow-y-auto p-6"
          onClick={(e) => e.stopPropagation()}
        >
          {modalContent}
        </div>
      </div>

      {/* Mobile: bottom sheet */}
      <div className="lg:hidden absolute inset-x-0 bottom-0">
        <div
          className="relative bg-white rounded-t-2xl max-h-[85dvh] overflow-y-auto px-4 pt-5 pb-8"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Drag handle */}
          <div className="flex justify-center mb-4">
            <div className="w-10 h-1 rounded-full bg-[#E8E2DA]" />
          </div>
          {modalContent}
        </div>
      </div>
    </div>
  );
}
